module.exports = __webpack_public_path__ + "prod/1.2.3/img/wechat.94cec41a.svg";